import { render } from "./InternationalTradeEconRev.vue?vue&type=template&id=602376b8&scoped=true"
import script from "./InternationalTradeEconRev.vue?vue&type=script&lang=js"
export * from "./InternationalTradeEconRev.vue?vue&type=script&lang=js"

import "./InternationalTradeEconRev.vue?vue&type=style&index=0&id=602376b8&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602376b8"]])

export default __exports__